import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo2.png'


const _withScopeId = n => (_pushScopeId("data-v-0d667337"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo-box" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_3 = { class: "login-box" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-container-header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "selected" }, "忘记密码")
], -1))
const _hoisted_5 = { class: "input-box" }
const _hoisted_6 = { class: "link-box" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin":"0 8px 0 0"} }, "已有账号", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_ui_form_item = _resolveComponent("ui-form-item")!
  const _component_ui_countdown = _resolveComponent("ui-countdown")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ui_form = _resolveComponent("ui-form")!
  const _component_ui_copyright = _resolveComponent("ui-copyright")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_ui_form, {
        class: "form-box",
        ref: "form"
      }, {
        default: _withCtx(() => [
          _hoisted_4,
          _createVNode(_component_ui_form_item, { class: "input-box" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.post.phone,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.post.phone) = $event)),
                name: "phone",
                placeholder: "请输入手机号"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_ui_form_item, { class: "input-box" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.post.code,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.post.code) = $event)),
                name: "code",
                placeholder: "输入短信验证码",
                maxlength: "10"
              }, {
                suffix: _withCtx(() => [
                  (_ctx.countdown)
                    ? (_openBlock(), _createBlock(_component_ui_countdown, {
                        key: 0,
                        onEnded: _cache[1] || (_cache[1] = ($event: any) => (_ctx.countdown = false))
                      }))
                    : (_openBlock(), _createBlock(_component_el_link, {
                        key: 1,
                        underline: false,
                        type: "primary",
                        onClick: _ctx.getCode
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("获取验证码")
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_input, {
              modelValue: _ctx.post.loginpwd,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.post.loginpwd) = $event)),
              "show-password": "",
              name: "loginpwd",
              placeholder: "设置密码（8-20个字符，包含字母数字）"
            }, null, 8, ["modelValue"])
          ]),
          _createVNode(_component_el_button, {
            class: "login-btn",
            size: "large",
            onClick: _ctx.request,
            type: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode("找回密码")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_el_link, {
              underline: false,
              type: "primary",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goto('/login')))
            }, {
              default: _withCtx(() => [
                _createTextVNode("登录")
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 512)
    ]),
    _createVNode(_component_ui_copyright)
  ]))
}